<template>
    <router-link :to="{ name: 'SpecialsSingle', params: { slug: slug }}">
        <div class="item-default __item-special">
            <div class="image">
                <ion-img :src="thumbnail" :alt="title" />
            </div>
            <div class="description">
                <div class="head">
                    <div class="date">{{ dateFrom }} - {{ dateTo }}</div>
                </div>
                <h3 class="title h5">{{ title }}</h3>
                <div v-if="excerpt" class="rte excerpt" v-html="excerpt"></div>
            </div>
        </div>
    </router-link>
</template>

<script>
    export default {
        name: 'ItemSpecials',
        props: {
            data : {
                type: [Array, Object],
                required : true
            }
        },
        computed:{
            thumbnail(){
                return this.data.thumbnail;
            },
            title(){
                return this.data.title;
            },
            excerpt(){
                return this.data.excerpt;
            },
            dateFrom(){
                return this.data.dateFrom;
            },
            dateTo(){
                return this.data.dateTo;
            },
            slug(){
                return this.data.slug;
            }
        }
    }
</script>